import 'select2';
import $ from 'jquery';

function starFormat(state) {
  if (!state.id) {
    return state.text;
  }

  const textParts = state.text.split('=stars=');

  const name = textParts[0];
  const rating = textParts[1];

  let starsHtml = '<span style="width:120px;display:inline-block;">&nbsp;</span>';

  if (rating !== 'null') {
    const fullStars = Math.floor(rating);
    const halfStar = (rating * 2) % 2;
    const emptyStars = 5 - fullStars - halfStar;

    starsHtml = '';
    for (let fullStar = 0; fullStar < fullStars; fullStar += 1) {
      starsHtml += '<i class="material-icons">star</i>';
    }
    if (halfStar === 1) {
      starsHtml += '<i class="material-icons">star_half</i>';
    }
    for (let emptyStar = 0; emptyStar < emptyStars; emptyStar += 1) {
      starsHtml += '<i class="material-icons">star_border</i>';
    }
  }

  const $option = $(`${'<span><span style="margin-right:10px;">'}${starsHtml}</span><span>${name}</span></span>`);
  return $option;
}

$(document).ready(() => {
  $('select.select2').select2({
    width: '100%',
  });

  $('select.select2-stars').select2({
    width: '100%',
    templateResult: starFormat,
    templateSelection: starFormat,
  });
});
